const messages = {
    bonus: {
        title: "Oversikt bonuskreditter",
        description:
            "Bonus i euro tildeles deltakende virksomheter på grunnlag av innsendte salgstall.",
        lastMonth: "Siste måned",
        currentMonth: "Løpende måned",
        totalCurrentYear: "Totalt løpende år",
        totalLastYear: "Totalt i fjor",
    },
    points: {
        title: "Oversikt punktkreditter",
        period: "Inneværende kalenderår ({year})",
        totalAwarded: "Totalt tildelte poeng",
        redeemed: "Løste inn poeng",
        totalBalance: "Total punktbalanse",
        redemptionRate: "Innløste poeng som prosent av tildelte poeng",
        averageAwarded: "Gjennomsnittlig tildelte poeng per kjøpt dekk",
        standardAwarded: "Nettopoeng fra beregnede salgslinjer, inkludert returer",
        bsPlusInclBooster: "Poeng fra salgslinjer med positivt antall",
        perTire: "Innløste poeng per kjøpt dekk",
    },
    tires: {
        title: "Oversikt antall dekk",
        description: "Dekk kjøpt av kundene",
        prevMonth: "Forrige måned",
        totalLastYear: "Totalt i fjor",
        purchaseIndirect: "Kjøp via grossist (indirekte)",
        purchaseDirect: "Kjøp via grossist (direkte)",
        totalCurrentYear: "Totalt løpende år",
        currentMonth: "Løpende måned",
    },
    participating: {
        title: "Oversikt over deltakende kunder",
        description:
            "Virksomheter som registrerer seg på BRIDGESTONE PLUS kan tilordnes av oss via kundenummer.",
        total: "Totalt",
        newThisMonth: "Nye denne måneden",
        newThisYear: "Nye dette året",
        createdInCurrentMonth: "Opprettet i løpende måned (av admin)",
        loginsCurrentYear: "Innlogginger løpende år (etter godkjenning av vilkår)"
    },
    brand: {
        title: "Merke",
        description: "Dine kjøp i detalj",
        centerTitle: "Etter\nmerke"
    },
    rim: {
        title: "Felg",
        centerTitle: "Per felg\nstørrelse"
    },
    tireGoals: {
        title: "Dekkmålsmål",
        subtitle: "Tjen poeng for dekkjøpene dine.",
        centerTitle: "Etter\ndekkstørrelse",
        tiresRemaining: "Gjenstående dekk",
        progressionTarget: "Fremdriftsmål: ",
        pointsEarnedPurchases: "poeng opptjent\nav\ndine kjøp",
        pointsEarnedBoosters: "poeng opptjent\nav\nboostere",
        purchasesDetail: "Dine kjøp i detalj",
        cta: "Finn ut mer om poengene dine",
        pointsTitle: "Dine poeng",
        pointsSubtitle: "Poeng opptjent på Bridgestone-kjøp",
        achievementsTitle: "Dine prestasjoner",
        achievementsSubtitle: "Din årlige forpliktelse:",
        achievementsSubtitle2: "dekk"
    },
    score: {
        title: 'Poengsum',
        total: 'Totalt',
        credits: 'Kreditter i',
        deductions: 'Fradrag i',
        unlockedPoints: 'Opplåste poeng',
        pendingPoints: 'Ventende poeng',
    },
    score_extended: {
        title1: "Punktbalanse",
        title2: "Bonus i euro",
        balance: "Punktbalanse",
        bonus_in_euro: "Bonus i euro",
        date: "Dato",
        added_points: "Poeng lagt til i",
        total_bands: "Totalt antall bånd",
        goal: "Mål",
        tyres_previous_year: "Dekk solgt i fjor",
        tyres_current_year: "Dekk solgt dette året",
        target_this_year: "Salgsmål dette året",
        bonus_this_year: "Opptjent bonus (€)",
        loyal_minimum: "Lojalitetsminimumsnivå",
        bonus_multiplier: "Bonus multiplikatorrate"
    },
    lastImport: {
        label:"Siste import av salgstall:",
        on: "den"
    },
    wholesalerTable: {
        title: "Deltakende kunder i detalj",
        description:
            "Nedenfor finner du virksomhetene som har registrert seg på BRIDGESTONE PLUS med selskapets kundenummer. " +
            "Du kan bruke filterne for annen sortering eller søkefunksjonen for å slå opp kunder.",
        columns: {
            customer_number: "Kundenr.",
            address_company_name: "Selskap",
            address_street: "Gate og husnummer",
            address_postal_code: "Postnummer",
            address_city: "Sted",
            last_registration: "Sist registrert",
            network: "Nettverk",
            profile_group: "Gruppe",
            tires_amount: "Dekkantall",
            point_balance: "Punktbalanse",
            bonus: "Bonus",
            details: "Detaljer"
        },
        searchPlaceholder: "Søk"
    },
    dealerTable: {
        columns: {
            date: "Dato",
            wholesaler_bs_plus: "Grossist BS+",
            customer_number: "Kundenummer",
            article: "Artikkel",
            brand: "Merke",
            product: "Produkt",
            type: "Type",
            inch: "Tommer",
            season: "Sesong",
            amount: "Antall",
            points: "Poeng",
            activity: "Aktivitet",
            total_points: "Totalt poeng"
        },
        title: "Forhandlertabell",
        description: "Oversikt over forhandleraktiviteter",
    },
    business_units: {
        title: "Forretningsenheter",
        centerTitle: "Per\nenhet",
    },
    season: {
        title: "Sesong",
        centerTitle: "Per årstid",
    },
}

export default {
    messages,
}
